import {
  ADD_MARITIAL_STATUS_FAIL,
  ADD_MARITIAL_STATUS_SUCCESS,
  ADD_MARITIAL_STATUS_REQUEST,
  DELETE_MARITIAL_STATUS_REQUEST,
  DELETE_MARITIAL_STATUS_SUCCESS,
  GETDETAIL_MARITIAL_STATUS_REQUEST,
  GETDETAIL_MARITIAL_STATUS_FAIL,
  GETDETAIL_MARITIAL_STATUS_SUCCESS,
  UPDATE_MARITIAL_STATUS_FAIL,
  UPDATE_MARITIAL_STATUS_SUCCESS,
  UPDATE_MARITIAL_STATUS_REQUEST,
  DELETE_MARITIAL_STATUS_FAIL,
  GETALL_MARITIAL_STATUS_FAIL,
  GETALL_MARITIAL_STATUS_SUCCESS,
  GETALL_MARITIAL_STATUS_REQUEST,
  CLEAR_MATRIAL_STATUS_RECORD,
} from "../constant/MaritialStatusConstant";

const initialState = {
  loading: false,
  action: "Maritial Status",
  result: [],
  success: false,
  singledata: [],
  message: "",
  error: "",
};

const MaritialStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_MARITIAL_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_MARITIAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GETALL_MARITIAL_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case GETDETAIL_MARITIAL_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETDETAIL_MARITIAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GETDETAIL_MARITIAL_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case ADD_MARITIAL_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_MARITIAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_MARITIAL_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,

        message: action.message,
      };

    case UPDATE_MARITIAL_STATUS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case UPDATE_MARITIAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),

        message: action.message,
      };
    case UPDATE_MARITIAL_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case DELETE_MARITIAL_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_MARITIAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_MARITIAL_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case CLEAR_MATRIAL_STATUS_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default MaritialStatusReducer;
